import { Outlet } from 'react-router-dom';

export const ApprovalOutlet = () => <Outlet />;
